import React from "react";
import axios from "axios";
import { inject, observer } from "mobx-react";
import withLocation from "lib/withLocation";
import navigate from "lib/navigate";
import { Helmet } from "react-helmet";
import qs from "query-string";

export const page = (WrappedComponent) => {
  @withLocation
  @inject("readerStore", "appStore")
  @observer
  class pageComp extends React.Component {
    constructor(props) {
      super(props);
      this.state = {};
    }

    componentDidMount() {
      let { search, appStore, readerStore } = this.props;
      let { fontSize } = appStore;
      let { session } = readerStore;
      if (search && search.domain) {
        this.props.appStore.setDomain(search.domain);
      } else {
        this.props.appStore.setDomain("");
      }
      if (session.fontSize && session.fontSize !== fontSize) {
        fontSize = session.fontSize;
        this.props.appStore.setFontSize(fontSize);
      }
      if (fontSize && fontSize !== "") {
        if (!document.body.classList.contains(fontSize)) {
          document.body.classList.add(fontSize);
        }
      }
    }

    UNSAFE_componentWillReceiveProps(props) {
      if (props.search && props.search.domain !== props.appStore.domain) {
        if (props.search.domain) {
          props.appStore.setDomain(props.search.domain);
        } else if (props.appStore.domain !== "") {
          props.appStore.setDomain("");
        }
      }
    }

    changeLangAttri(lang) {
      let langAttri = "zh-Hant-TW";
      if (lang === "zh") {
        langAttri = "zh-Hant-TW";
      } else if (lang === "en") {
        langAttri = "en-US";
      }
      return langAttri;
    }

    render() {
      let { readerStore, appStore, location, search } = this.props;
      let params = { ...search };
      let { globalConfig, checkedGuest } = appStore;
      if (globalConfig["jumperrwd.common.isMaintenance"] === "1") {
        if (!location.pathname.includes("/maintenance")) {
          navigate("/maintenance");
          return <></>;
        } else {
          let { language } = this.props.i18n;
          return (
            <>
              <Helmet htmlAttributes={{ lang: this.changeLangAttri(language) }}>
                <title>{this.props.t("jumper.sys.name") + "維修中"}</title>
                <link rel="icon" href={"/file/images/favicon.png"} />
              </Helmet>
              <WrappedComponent {...this.props} />
            </>
          );
        }
      } else {
        let { auth, session } = readerStore; //需要取值，否則auth改變，WrappedComponent的props不會檢查
        let needLogin =
          !auth &&
          (globalConfig["hyint.module.isIndexGuestLogin"] === "0" ||
            (globalConfig["jumper.common.guest.campus"] === "0" &&
              session.useUnitOutsite === "0") ||
            (globalConfig["jumper.common.guest.offcampus"] === "0" &&
              session.useUnitOutsite === "1") ||
            (globalConfig["jumperrwd.login.guestCheck"] === "1" &&
              session.checkedGuest !== "1" &&
              checkedGuest !== 1));
        let useLogin2 = globalConfig["jumperrwd.common.useLogin2"] === "1";
        if (
          this.props.appStore.loginRedirect !== null &&
          !location.pathname.includes("/login")
        ) {
          this.props.appStore.setLoginRedirect(null);
        }
        if (location.pathname.includes("/login2") && !useLogin2) {
          navigate("/login");
        } else if (
          !location.pathname.includes("/sendURLApiV3") &&
          !location.pathname.includes("/searchRedirectEDS") &&
          !location.pathname.includes("/dLink") &&
          !location.pathname.includes("/oauth") &&
          !location.pathname.includes("/hySSOLogin") &&
          !location.pathname.includes("/openidssologin") &&
          !location.pathname.includes("/openidSSOLoginAleph") &&
          needLogin &&
          !location.pathname.includes("/login")
        ) {
          axios
            .get("/api/jumperrwdWs/setSession?key=forceNews&value=0")
            .then(() => {});
          let path =
            Object.keys(params).length > 0
              ? [location.pathname, qs.stringify(params)].join("?")
              : location.pathname;
          this.props.appStore.setLoginRedirect(path);
          if (appStore.loginPage && appStore.loginPage !== "") {
            navigate("/" + appStore.loginPage);
          } else {
            navigate("/login");
          }
        } else {
          let { language } = this.props.i18n;
          let gtmAccount = globalConfig["hyint.core.gtmAccount"] || "";
          let keyboardInput = globalConfig["jumperrwd.common.keyboardInput"];
          let title = this.props.t("jumper.sys.name");
          let pagePath = location.pathname.replaceAll("/", "").split("?")[0];
          if (pagePath === "") {
            pagePath = "index";
          }
          if (pagePath === "searchInteractionList") {
            let { resourceType } = params;
            if (resourceType === "reading") {
              pagePath = "hotReadingList";
            } else if (resourceType === "commend") {
              pagePath = "hotCommendList";
            }
          }
          if (pagePath === "searchInteractionDetail") {
            let { hotreading_sn, hotcommend_sn } = params;
            if (hotreading_sn !== "") {
              pagePath = "hotReading";
            } else if (hotcommend_sn !== "") {
              pagePath = "hotCommend";
            }
          }
          if (
            this.props.t("jumperrwd.page." + pagePath) !==
            "jumperrwd.page." + pagePath
          ) {
            title += " - " + this.props.t("jumperrwd.page." + pagePath);
          }
          let layoutStyleType =
            globalConfig["jumperrwd.layout.styleType"] || "1";
          return (
            <>
              <Helmet htmlAttributes={{ lang: this.changeLangAttri(language) }}>
                {gtmAccount !== "" && (
                  <script>
                    {`
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({ platform: "gatsby" });
                    (function (w, d, s, l, i) {
                      w[l] = w[l] || [];
                      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
                      var f = d.getElementsByTagName(s)[0],
                        j = d.createElement(s),
                        dl = l != "dataLayer" ? "&l=" + l : "";
                      j.async = true;
                      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl + "";
                      f.parentNode.insertBefore(j, f);
                    })(window, document, "script", "dataLayer", "` +
                      gtmAccount +
                      `");
                  `}
                  </script>
                )}
                <title>{title}</title>
                <link rel="icon" href={"/file/images/favicon.png"} />
                {keyboardInput === "1" && (
                  <script src={"/file/js/keyboard.js"} type="text/javascript" />
                )}
              </Helmet>
              <WrappedComponent
                layoutStyleType={layoutStyleType}
                {...this.props}
              />
            </>
          );
        }
        return <></>;
      }
    }
  }
  return pageComp;
};
